module.exports = __webpack_public_path__ + "static/media/stringa_fondochiaro.47b31e97.png";